import { Component, OnInit } from '@angular/core';
import { HelperService } from '../service/helper/helper.service';
import { Router } from '@angular/router';
import { MatGridListModule, MatDialog, MatDialogConfig } from '@angular/material/';

import { ModalComponent } from '../modal/modal.component';


@Component({
  selector: 'app-receive',
  templateUrl: './receive.component.html',
  styleUrls: ['./receive.component.css']
})
export class ReceiveComponent implements OnInit {

  public seed;
  constructor(public dialog: MatDialog,public router: Router, public helper: HelperService) { }

  ngOnInit() {
    this.seed = "NIT:" + this.helper.getAddress();
    console.log(this.seed);
    this.helper.selAcc.subscribe(x=>{
      console.log(this.helper.accountListBalance)
      this.seed = "NIT:" + this.helper.getAddress();
    })
  }

  route(linkName) {
    const link = ['/' + linkName];
    this.router.navigate(link);
  }

  showPopup(){
    var popup = document.getElementById("myPopup");
 popup.classList.remove("hidden");
 popup.classList.add("show");
 setTimeout(this.newFunc, 1000);
  }

  newFunc(){
    var popup = document.getElementById("myPopup");
       popup.classList.remove("show");
     popup.classList.add("hidden");
    }


  openDialog() {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      id: 1,
      title: 'Angular For Beginners'
    };
    dialogConfig.minWidth='300px'
    // this.dialog.dialogContainer = {

    // }

    dialogConfig.position = {
      top:'68px',
      right: '0',

    };

    this.dialog.open(ModalComponent, dialogConfig);
}
}
